export default "__VITE_ASSET__2wmZmrbM__"